<opac-dialog #dialog [title]="'user.events.addCalendar' | translate" (closed)="dialog.closeDialog()">
  <div class="platforms">
    <div *ngFor="let platform of platforms" class="platform" (click)="addToCalendar(platform?.link)">
      <opac-icon [icon]="platform?.icon"></opac-icon>
      <p>{{ platform?.name }}</p>
    </div>
  </div>
</opac-dialog>